import { types } from "../types/types";


const initialstate = {
    contenido: [{
        name: "osiris",
        apeelido: "soler ramirez"
    }],
    active: null
}


export const exampleReducer = (state = initialstate, action) => {
    switch (action.type) {
        default:
            return state;
    }

}